// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-container {
  position: relative;
  top: 0;
  height: 100%;
  z-index: 100;
}

.modal-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 51, 153, 0.6901960784);
  z-index: 14;
}

.modal-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-color: transparent;
}
.modal-overlay.blue {
  background-color: var(--color-primary-blue);
}

.reveal {
  position: absolute;
  top: 25.7rem;
  left: 43.25rem;
  background: #f5db6c;
  background-image: linear-gradient(0deg, rgba(var(--ion-color-avatar-choose-contrast-rgb), 0) 0%, rgba(var(--ion-color-avatar-choose-contrast-rgb), 0.48) 100%);
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  border-radius: 6px 24px 24px 24px;
  width: 10rem;
  height: 2rem;
  border: 0.083rem solid var(--color-primary-blue);
  z-index: 10;
}

.topic-box {
  top: 6rem;
}

.text-title {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  text-align: center;
  font-size: 1.167rem;
}

.box2 {
  position: relative;
  width: 25rem;
  margin: 2.083rem auto;
  padding: 0.833rem;
  text-align: center;
  border-radius: 0.458rem;
  background: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset;
}

.btn-group .button1 {
  background-color: var(--color-primary-blue);
  border: none;
  color: white;
  padding: 0.7rem 1.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 0.5rem;
}

.btn-group .button2 {
  border: 0.118rem solid var(--color-primary-blue);
  border-radius: 1.33rem;
  color: var(--color-primary-blue);
  text-align: center;
  padding: 0.6rem 1.5rem;
  margin-left: 1.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 0.5rem;
}

.text2 {
  margin-top: 0.5rem;
  padding-left: 3rem;
  padding-right: 3rem;
  font-size: 0.833rem;
  color: var(--color-primary-blue);
  text-align: center;
  line-height: 1.333rem;
}

.button-end {
  border-end-end-radius: 3rem;
  border-start-end-radius: 3rem;
}

.button-start {
  border-end-start-radius: 3rem;
  border-start-start-radius: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/phaser-overlay/phaser-overlay.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,UAAA;EACA,6BAAA;AAAF;AACE;EACE,2CAAA;AACJ;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,8JAAA;EAKA,yCAAA;EACA,iCAAA;EACA,YAAA;EACA,YAAA;EACA,gDAAA;EACA,WAAA;AAJF;;AAOA;EACE,SAAA;AAJF;;AAOA;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yFAAA;AAJF;;AAOA;EACE,2CAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,gDAAA;EACA,sBAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;AAJF;;AAMA;EACE,2BAAA;EACA,6BAAA;AAHF;;AAMA;EACE,6BAAA;EACA,+BAAA;AAHF","sourcesContent":[".custom-container {\n  position: relative;\n  top: 0;\n  height: 100%;\n  z-index: 100;\n}\n\n.modal-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: #003399b0;\n  z-index: 14;\n}\n\n.modal-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  // background-color: transparent;\n  z-index: 0;\n  background-color: transparent;\n  &.blue {\n    background-color: var(--color-primary-blue);\n  }\n}\n\n.reveal {\n  position: absolute;\n  top: 25.7rem;\n  left: 43.25rem;\n  background: #f5db6c;\n  background-image: linear-gradient(\n    0deg,\n    rgba(var(--ion-color-avatar-choose-contrast-rgb), 0) 0%,\n    rgba(var(--ion-color-avatar-choose-contrast-rgb), 0.48) 100%\n  );\n  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);\n  border-radius: 6px 24px 24px 24px;\n  width: 10rem;\n  height: 2rem;\n  border: 0.083rem solid var(--color-primary-blue);\n  z-index: 10;\n}\n\n.topic-box {\n  top: 6rem;\n}\n\n.text-title {\n  color: var(--color-primary-blue);\n  letter-spacing: 0;\n  line-height: 1.333rem;\n  text-align: center;\n  font-size: 1.167rem;\n}\n\n.box2 {\n  position: relative;\n  width: 25rem;\n  margin: 2.083rem auto;\n  padding: 0.833rem;\n  text-align: center;\n  border-radius: 0.458rem;\n  background: var(--color-white);\n  box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0px 1px,\n    rgb(209, 213, 219) 0px 0px 0px 1px inset;\n}\n.btn-group .button1 {\n  background-color: var(--color-primary-blue);\n  border: none;\n  color: white;\n  padding: 0.7rem 1.5rem;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 0.9rem;\n  cursor: pointer;\n  margin-top: 0.5rem;\n}\n\n.btn-group .button2 {\n  border: 0.118rem solid var(--color-primary-blue);\n  border-radius: 1.33rem;\n  color: var(--color-primary-blue);\n  text-align: center;\n  padding: 0.6rem 1.5rem;\n  margin-left: 1.5rem;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 0.9rem;\n  cursor: pointer;\n  margin-top: 0.5rem;\n}\n\n.text2 {\n  margin-top: 0.5rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  font-size: 0.833rem;\n  color: var(--color-primary-blue);\n  text-align: center;\n  line-height: 1.333rem;\n}\n.button-end {\n  border-end-end-radius: 3rem;\n  border-start-end-radius: 3rem;\n}\n\n.button-start {\n  border-end-start-radius: 3rem;\n  border-start-start-radius: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
